<script>
  import { menuSearch, menuSearchCands } from "../editor/search.js";
  import { openSystemTooltip, closeSystemTooltip } from "../editor/utility.js";
  export let inputFocusAction, inputBlurAction;
  let searchKey;
  let searchOutput = [];
  $: {
    if (searchKey?.length > 0) {
      searchOutput = menuSearch(searchKey, menuSearchCands);
    } else {
      cancelSearch();
    }
  }
  function cancelSearch() {
    searchKey = "";
    searchOutput = [];
  }
</script>

<div id="menu-search">
  <div class="search-wrap">
    <input
      type="text"
      class="search"
      bind:value={searchKey}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      placeholder="Search menu..."
      alt="search menu"
    />
  </div>
  {#if searchOutput.length > 0}
    <div class="search-result">
      <h6>Search results:</h6>
      <ul>
        {#each searchOutput as output}
          <li class="search-output">
            <button
              type="button"
              on:click={() => {
                output.cmd();
                cancelSearch();
              }}>{output.title}</button
            >
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>

<style>
  #menu-search {
    margin-top: -5px;
    margin-left: 0.5rem;
    width: 180px;
    min-width: 145px;
  }
  #menu-search .search-wrap {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    line-height: 100%;
    padding: 2px 0 2px 0;
    height: 33px;
  }
  .search-wrap input.search {
    width: 100%;
    height: 27px;
    padding: 0.2rem 0.5rem;
    margin: 0;
    border-radius: var(--default-radius);
    background-color: white;
    border: 1px solid #dddddd;
    font-size: 0.8rem;
  }
  .search-result {
    width: 100%;
    height: auto;
    max-height: 220px;
    overflow-y: scroll;
    padding: 0.2rem 0.5rem;
    margin: 2px 0 0 0;
    border-radius: var(--default-radius);
    background-color: white;
    border: 1px solid #dddddd;
    font-size: 0.8rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 3px 4px rgba(0, 0, 0, 0.05);
  }
  .search-result h6 {
    margin-bottom: 3px;
    padding: 0;
    font-size: 0.8rem;
    font-style: italic;
    font-weight: 300;
    color: #454545;
  }
  .search-result ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .search-output {
    margin: 0;
    padding: 0;
    border: 0;
  }
  .search-output button {
    appearance: none;
    width: calc(100% + 0.5rem);
    padding: 0.2rem 0.25rem;
    border: 0;
    margin: 0 -0.25rem;
    font-size: 0.8rem;
    background: transparent;
    text-align: left;
    line-height: 100%;
    border-radius: var(--default-radius);
  }
  .search-output button:hover {
    background-color: #f5f5f5 !important;
    font-weight: 500;
  }
</style>
